import { Injectable } from '@angular/core';
import { Players } from '../models/players';
import { PlayerScores } from '../models/player-scores';
import { Score } from '../models/score';

@Injectable({
  providedIn: 'root'
})
export class BuildPlayersService {

  constructor() { }

  buildPlayers(): Players {
    let i = 0;
    const pd = new Players();
    pd.name = 'players';
    pd.playerScores = [];

    const p1 = new PlayerScores();
    p1.name = 'Player 1';
    p1.order = i++;
    p1.scores = [
      new Score(), new Score(), new Score(), new Score(), new Score(),
      new Score(), new Score(), new Score(), new Score(), new Score(),
      new Score(), new Score(), new Score(), new Score(), new Score(),
      new Score(), new Score(), new Score()
    ];
    pd.playerScores.push(p1);

    const p2 = new PlayerScores();
    p2.name = 'Player 2';
    p2.order = i++;
    p2.scores = [
      new Score(), new Score(), new Score(), new Score(), new Score(),
      new Score(), new Score(), new Score(), new Score(), new Score(),
      new Score(), new Score(), new Score(), new Score(), new Score(),
      new Score(), new Score(), new Score()
    ];
    pd.playerScores.push(p2);

    const p3 = new PlayerScores();
    p3.name = 'Player 3';
    p3.order = i++;
    p3.scores = [
      new Score(), new Score(), new Score(), new Score(), new Score(),
      new Score(), new Score(), new Score(), new Score(), new Score(),
      new Score(), new Score(), new Score(), new Score(), new Score(),
      new Score(), new Score(), new Score()
    ];
    pd.playerScores.push(p3);

    const p4 = new PlayerScores();
    p4.name = 'Player 4';
    p4.order = i++;
    p4.scores = [
      new Score(), new Score(), new Score(), new Score(), new Score(),
      new Score(), new Score(), new Score(), new Score(), new Score(),
      new Score(), new Score(), new Score(), new Score(), new Score(),
      new Score(), new Score(), new Score()
    ];
    pd.playerScores.push(p4);

    return pd;
  }
}
